// TextEditor.js
import { connect } from 'react-redux';
import TextEditor from '../component/TextEditor.jsx';
import pushToastr from '../action/pushToastr.js';

const mapDispatchToProps = dispatch => {
  return {
    pushToastr: text =>
      dispatch(
        pushToastr({
          textKey: text,
          durationSec: 5,
          color: 'error',
        })
      ),
  };
};

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(
  TextEditor
);
